import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PaymentRequestsListComponent } from './payment-requests-list/payment-requests-list.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: PaymentRequestsListComponent,
        data: {
          title: 'Payment Requests'
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PaymentRequestsRoutingModule {
}
